import { createSlice } from "@reduxjs/toolkit";
import { PromocionSliceInterface } from "interfaces/promociones/promocionesInterface";

export const promocionSlice = createSlice({
  name: "promocion",
  initialState: {
    solicitudPromocion: [],
    solicitudPromocionLaborales: [],
    solicitudPromocionPenales: [],
    tiposJuzgados: false,
    promocionSelected: null,

    /**promociones - contestacion-demanda */

    lstMaterias: [],
    lstJuzgados: [],
    lstInstancias: [],
    lstTipoCarpetas: [],
    selectJuzgado: 0,
    totalSizeFile: 0,

    formBusquedaCarpetaJudicial: null,
    enLinea: false,
    tipoPenal: false,
    showModalNuevaPromocion: false,
    materiaId: null,
    carpetaJudicial: [],
    /**promociones - generar solicitud demanda */
    file: null,
    stepPromocion: 0,
    secretoFojasForm: null,
    notasSintesisForm: null,
    responseSolicitudPromocion: null,
    documentSelectedPromocion: null,
    listUploaddedFiles: [],
    capturaPartesPromoventes: [],
    initialCapturaPromoventes: [],
    solicitudPromocionDocumentos: [],
    successRegisterPromocion: false,
    solicitudPromocionSelected: null,
    promovente: null,

  } as PromocionSliceInterface,

  reducers: {
    onSolicitudesPromociones: (state, { payload }) => {
      state.solicitudPromocion = payload;
      state.solicitudPromocionDocumentos = [];
    },
    onSolicitudesPromocionesPenales: (state, { payload }) => {
      state.solicitudPromocionPenales = payload;
    },
    onSolicitudesPromocionesLaborales: (state, { payload }) => {
      state.solicitudPromocionLaborales = payload;
      state.solicitudPromocionDocumentos = [];
    },
    onChangeTiposJuzgados: (state) => {
      state.tiposJuzgados = !state.tiposJuzgados;
    },
    onAddPromocionSeleccionada: (state, { payload }) => {
      state.promocionSelected = payload;
    },
    onAddJuzgadoSeleccionado: (state, { payload }) => {
      state.selectJuzgado = payload;
    },

    /**actions promociones - contestacion-demanda */
    onAddMateriasOrdinarias: (state, { payload }) => {
      state.lstMaterias = payload;
    },
    onAddJuzgadosOrdinarias: (state, { payload }) => {
      state.lstJuzgados = payload;
    },
    onAddInstanciasOrdinarias: (state, { payload }) => {
      state.lstInstancias = payload;
    },
    onIsEnLinea: (state, { payload }) => {
      state.enLinea = payload;
    },
    onIsTipoPenal: (state, { payload }) => {
      state.tipoPenal = payload;
    },
    onAddSinzeFile: (state, { payload }) => {
      state.totalSizeFile = payload;
    },

    onAddTipoCarpetas: (state, { payload }) => {
      state.lstTipoCarpetas = payload;
    },
    onShowModalNuevaPromocion: (state, { payload }) => {
      state.showModalNuevaPromocion = payload;
    },
    onAddIdMateria: (state, { payload }) => {
      state.materiaId = payload;
    },
    onAddCarpetaJudicial: (state, { payload }) => {
      state.carpetaJudicial = [payload];
    },
    onAddFormBusquedaCarpetaJudicial: (state, { payload }) => {
      state.formBusquedaCarpetaJudicial = payload;
    },

    /**Actions solicitud promocion electronica */
    onAddCapturaPartesPromoventes: (state, { payload }) => {
      state.capturaPartesPromoventes = payload;
    },
    onChangeStepSolicitudPromocion: (state, { payload }) => {
      state.stepPromocion = payload;
    },
    onAddSecretoNotasForm: (state, { payload }) => {
      state.secretoFojasForm = payload;
    },
    onAddPromoventePortada: (state, { payload }) => {
      state.promovente = payload;
    },
    onAddNotasSintesisForm: (state, { payload }) => {
      state.notasSintesisForm = payload;
    },
    onAddResponseSolicitudPromocion: (state, { payload }) => {
      state.responseSolicitudPromocion = payload;
    },
    onAddFileStep: (state, { payload }) => {
      state.file = payload;
    },
    onAddListUploaddedFilesPromocion: (state, { payload }) => {
      state.listUploaddedFiles = payload;
      state.file = null;
    },
    onAddDocumentSelectedPromocion: (state, { payload }) => {
      state.documentSelectedPromocion = payload;
    },
    onAddInitialCapturaPromovente: (state, { payload }) => {
      state.initialCapturaPromoventes = payload;
    },
    onResetStateStepOne: (state) => {
      state.secretoFojasForm = null;
      state.notasSintesisForm = null;
      state.capturaPartesPromoventes = [];
      state.initialCapturaPromoventes = [];
    },
    onAddSuccessRegisterPromocion: (state, { payload }) => {
      state.successRegisterPromocion = payload;
    },
    onAddSolicitudPromocionSelected: (state, { payload }) => {
      state.solicitudPromocionSelected = payload;
    },
    onAddSolicitudPromocionDocumentos: (state, { payload }) => {
      state.solicitudPromocionDocumentos = payload;
    },
    onUpdateListSolicitudesPromociones: (state, { payload }) => {
      state.solicitudPromocion = state.solicitudPromocion.filter(
        (promocion) => promocion.idSolicitudActuacion !== payload
      );
    },
    /**reset state */
    onAllResetPromocionesState: (state) => {
      state.solicitudPromocion = [];
      state.solicitudPromocionLaborales = [];
      state.solicitudPromocionPenales = [];
      state.tiposJuzgados = false;
      state.promocionSelected = null;
      state.lstMaterias = [];
      state.lstJuzgados = [];
      state.lstInstancias = [];
      state.lstTipoCarpetas = [];
      state.formBusquedaCarpetaJudicial = null;
      state.enLinea = false;
      state.tipoPenal = false;
      state.showModalNuevaPromocion = false;
      state.materiaId = null;
      state.carpetaJudicial = [];
      state.file = null;
      state.stepPromocion = 0;
      state.secretoFojasForm = null;
      state.notasSintesisForm = null;
      state.responseSolicitudPromocion = null;
      state.documentSelectedPromocion = null;
      state.listUploaddedFiles = [];
      state.capturaPartesPromoventes = [];
      state.initialCapturaPromoventes = [];
      state.successRegisterPromocion = false;
      state.solicitudPromocionSelected = null;
      state.selectJuzgado = 0;
      state.totalSizeFile = 0;
    },
  },
});

//actions creators are generated for each case reducer function
export const {
  onAddPromocionSeleccionada,
  onChangeTiposJuzgados,
  onSolicitudesPromociones,
  onSolicitudesPromocionesPenales,
  onSolicitudesPromocionesLaborales,
  onAddMateriasOrdinarias,
  onAddJuzgadosOrdinarias,
  onAddInstanciasOrdinarias,
  onIsEnLinea,
  onIsTipoPenal,
  onAddTipoCarpetas,
  onShowModalNuevaPromocion,
  onAddIdMateria,
  onAllResetPromocionesState,
  onAddCarpetaJudicial,
  onAddFormBusquedaCarpetaJudicial,
  onChangeStepSolicitudPromocion,
  onAddCapturaPartesPromoventes,
  onAddSecretoNotasForm,
  onAddNotasSintesisForm,
  onAddResponseSolicitudPromocion,
  onAddListUploaddedFilesPromocion,
  onAddFileStep,
  onAddDocumentSelectedPromocion,
  onAddInitialCapturaPromovente,
  onResetStateStepOne,
  onAddSuccessRegisterPromocion,
  onAddSolicitudPromocionSelected,
  onAddSolicitudPromocionDocumentos,
  onUpdateListSolicitudesPromociones,
  onAddPromoventePortada,
  onAddJuzgadoSeleccionado,
  onAddSinzeFile,
} = promocionSlice.actions;
